import { createCollectionReducer } from 'ext/lib/collections';
import { TYPE } from './actions';

export default createCollectionReducer(TYPE);

export const selectApps = state => state[TYPE];
export const selectApp = (state, id) => selectApps(state)[id];
